import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Dimmer, Loader } from 'semantic-ui-react';
import './LoadingOverlay.scss';

function LoadingOverlay({ active, size, children, inline, className }) {
  return (
    <Dimmer.Dimmable
      dimmed={active}
      className={classNames('loading-overlay-dimmer', className)}
    >
      <Dimmer active={active} inverted>
        <Loader size={size} active inline={inline} />
      </Dimmer>
      {children}
    </Dimmer.Dimmable>
  );
}

LoadingOverlay.defaultProps = {
  size: 'large',
  inline: 'centered',
};

LoadingOverlay.propTypes = {
  active: PropTypes.bool,
  children: PropTypes.any,
  size: PropTypes.string,
  inline: PropTypes.any,
  className: PropTypes.string,
};

export default LoadingOverlay;
